import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgScalable = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M12.5001 17.5V15H9.16675V6.66667H7.50008V9.16667H1.66675V2.5H7.50008V5H12.5001V2.5H18.3334V9.16667H12.5001V6.66667H10.8334V13.3333H12.5001V10.8333H18.3334V17.5H12.5001Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgScalable);
export default ForwardRef;
